export const INITIALS_AVATAR = 'initials';

const INITIALS_COLOR_PALETTE = [
  '#4C6EF5',
  '#F76707',
  '#2F9E44',
  '#E64980',
  '#7048E8',
  '#1098AD',
  '#F59F00',
  '#E03131',
];

export const getInitials = (name?: string | null, surname?: string | null): string => {
  const first = name?.trim()?.[0] ?? '';
  const last = surname?.trim()?.[0] ?? '';
  const initials = `${first}${last}`.toUpperCase();
  return initials || '?';
};

export const getInitialsColor = (name?: string | null, surname?: string | null): string => {
  const key = `${name ?? ''}${surname ?? ''}`;
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  return INITIALS_COLOR_PALETTE[Math.abs(hash) % INITIALS_COLOR_PALETTE.length];
};
